import { useEffect, useState, useCallback } from 'react';

// Captures the browser's "beforeinstallprompt" event (Chrome/Edge/Android)
// so a custom "Download App" button can trigger the native install prompt.
// On iOS Safari there's no such event — canInstall stays false and the UI
// should fall back to "Add to Home Screen" instructions.
export const usePwaInstall = () => {
  const [deferredEvent, setDeferredEvent] = useState(null);
  const [installed, setInstalled] = useState(
    () => window.matchMedia?.('(display-mode: standalone)').matches || false
  );

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredEvent(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferredEvent(null);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredEvent) return 'unavailable';
    deferredEvent.prompt();
    const { outcome } = await deferredEvent.userChoice;
    setDeferredEvent(null);
    return outcome; // 'accepted' | 'dismissed'
  }, [deferredEvent]);

  return { canInstall: !!deferredEvent && !installed, installed, promptInstall };
};
